import type { DotsCoefficients, ScoringSex } from './types';

export const DOTS_COEFFICIENTS: Record<ScoringSex, DotsCoefficients> = {
  male: {
    a: -0.000001093,
    b: 0.0007391293,
    c: -0.1918759221,
    d: 24.0900756,
    e: -307.75076,
  },
  female: {
    a: -0.0000010706,
    b: 0.0005158568,
    c: -0.1126655495,
    d: 13.6175032,
    e: -57.96288,
  },
};

/**
 * Converts pounds to kilograms.
 *
 * @param lb Weight in pounds.
 * @returns Weight in kilograms.
 */
export function lbToKg(lb: number): number {
  return lb * 0.45359237;
}

/**
 * Calculates the DOTS coefficient for a given body weight and sex.
 *
 * @param bodyWeightLb Body weight in pounds.
 * @param sex The biological sex of the lifter.
 * @returns The DOTS coefficient.
 */
export function calculateDotsCoefficient(bodyWeightLb: number, sex: ScoringSex): number {
  const bwKg = lbToKg(bodyWeightLb);
  const { a, b, c, d, e } = DOTS_COEFFICIENTS[sex];
  const denominator =
    a * Math.pow(bwKg, 4) + b * Math.pow(bwKg, 3) + c * Math.pow(bwKg, 2) + d * bwKg + e;

  return 500 / denominator;
}

/**
 * Calculates the DOTS value for a specific lift, body weight, and sex.
 *
 * @param liftLb The weight of the lift in pounds.
 * @param bodyWeightLb The lifter's body weight in pounds.
 * @param sex The lifter's biological sex.
 * @returns The DOTS value.
 */
export function calculateDotsValue(liftLb: number, bodyWeightLb: number, sex: ScoringSex): number {
  const liftKg = lbToKg(liftLb);
  const coeff = calculateDotsCoefficient(bodyWeightLb, sex);
  return liftKg * coeff;
}
